import React, { useState } from 'react';
import {
  Paper,
  Chip,
  ButtonGroup,
  Button,
} from '@mui/material';
import {
  Link as RouterLink,
  MemoryRouter,
} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
//import Button from 'react-bootstrap/Button';
//import Col from 'react-bootstrap/Col';
//import Form from 'react-bootstrap/Form';
//import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Link, Navigate, useParams, useSearchParams } from "react-router-dom";
//import Form, { EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';

import Form, {
  ButtonItem,
  GroupItem,
  SimpleItem,
  Label,
  CompareRule,
  EmailRule,
  PatternRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
  AsyncRule,
  Item,
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import 'devextreme-react/autocomplete';

import utils from '../utils'
import ServiceUserForm from './ServiceUserForm';
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import TextBox from 'devextreme-react/text-box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

// ************************************************************
// ************************************************************
// ************************************************************

export const ComputerVerifyComponentWrapper = (props) => {
  //const { bearer_value, activation_id } = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  var bearer_value = searchParams.get("b")
  var activation_id = searchParams.get("act")
  const navigate = useNavigate()
  return <ComputerVerify 
    bearer_value={bearer_value} 
    activation_id={activation_id} 
    navigate={navigate} 
    {...props} 
    />
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  // https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
class ComputerVerify extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      user: {
        confirm_num: "000000",
      },
      errorMessage: undefined,
      completed: false,
      computerInfo: undefined,      
    }
    this.form = React.createRef()
  }
  componentDidMount() {
    console.log("bearer_value: ", this.props.bearer_value)
    console.log("activation_id: ", this.props.activation_id)
    
    AuthService.getComputerInfo(this.props.bearer_value, this.props.activation_id).then(data => {
      if (data.is_valid) {
        //console.log(data.payload)
        this.setState({
          computerInfo: data.payload,
          loading: false,
        })
      } else {
        //console.log(data)
        this.setState({ 
          errorMessage: data.message,
          loading: false,
        })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ loading: false })
    })
  }
  btn_submit_click() {
    console.log("VERIFY", this.state.user)    
    this.setState({ 
      loading: true,
    })
    AuthService.getComputerVerify(
      this.props.bearer_value, 
      this.props.activation_id,
      this.state.user.confirm_num).then(data => {

      if (data.is_valid) {
        this.setState({ 
          loading: false,
          completed: true,
        })
      } else {
        console.log("data" , data)
        this.setState({ 
          loading: false,
        })
        this.notifySomething(data.message, "error")
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        loading: false,
      })
      this.notifySomething("Unknown error", "error")
    })  
  }
  // funzione per visualizzare un messaggio che poi scompare in automatico
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  render() {
    if (this.state.loading) return <LoadingSpinner />
    
    if (this.state.completed) {
      return (
        <div className="container-sm">
          <Alert severity="success">
            <AlertTitle>Registration completed</AlertTitle>
            You can now wait the mail with the license file or contact your reseller.
          </Alert>
        </div>
      )
    }

    if (this.state.errorMessage) {
      return (
        <div className="container-sm">
          <Alert severity="error">
            <AlertTitle>{this.state.errorMessage}</AlertTitle>
            If something has gone wrong, contact your reseller.
          </Alert>
        </div>
      )
    }

    return (
      <>
        <div>
          <div className="container-sm">
            <Alert severity="info">
              <AlertTitle>Register your copy of {this.state.computerInfo.program_name}</AlertTitle>
              User code: <strong>{this.state.computerInfo.user_code}</strong>
            </Alert>
          </div>
          <br />
          <div className="container-sm">
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={0}
                  aria-label="basic tabs example">
                  <Tab label="Verify email address" {...a11yProps(0)} />                  
                </Tabs>
              </Box>
              <TabPanel value={0} index={0}>

                <form>
                  <div>
                    <p>To complete the registration, enter the number that you have received by email.</p>                    
                    <p><strong>If you have not received that number contact your reseller.</strong></p>
                  </div>
                  <br />
                  <Form
                    ref={this.form}
                    formData={this.state.user}
                    readOnly={false}
                    showColonAfterLabel={true}
                    //showValidationSummary={true}
                    labelLocation="left"
                    minColWidth={200}
                    colCount={2}
                    validationGroup="userDataValidationGroup" >

                    <GroupItem caption="Confirmation">
                      <SimpleItem
                        dataField="confirm_num"
                        editorType="dxTextBox"                        
                        editorOptions={{
                          readOnly: false,
                          width: 100,
                        }} >
                        <StringLengthRule
                          min={6}
                          max={6}
                          message="You must enter 6 digits" />
                        <RequiredRule message="Confirm number is required" />
                        <PatternRule
                          message="Allowed digit only"
                          pattern={/^[0-9]*$/} />
                        <Label visible={true} text="Number" />
                      </SimpleItem>
                    </GroupItem>

                  </Form>
                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="contained"
                      size="medium"
                      onClick={() => {
                        var res = this.form.current.instance.validate()
                        if (res.isValid) {
                          this.btn_submit_click()
                        } else {
                          console.log(res)
                        }
                      }} >
                      SUBMIT
                    </Button>
                  </Stack>
                  <br />
                </form>

              </TabPanel>
            </Box>
          </div>
        </div>
      </>
    )
  }
}
